import moment from 'moment'
import { color } from 'styles/colors'
import _ from 'underscore'
import { replace } from 'helpers/formatters'
import { CustomerAdoption } from 'types/CustomerAdoption'

const OPTED_IN = 'Opted In'
const SOME_SYSTEMS_OPTED_IN = 'Some Systems Opted In'
const OPTED_OUT = 'Opted Out'
const NO_SYSTEMS = 'No Systems'

const LAYOUT: Partial<Plotly.Layout> = {
  margin: { t: 20, b: 20, l: 40, r: 40, pad: 0 },
  showlegend: false,
  autosize: true
}

const DATA: Plotly.Data = {
  type: 'pie',
  showlegend: false,
  textinfo: 'value',
  textposition: 'outside',
  texttemplate: '<b>%{value}</b>',
  outsidetextfont: {
    family: 'Inter',
    size: 15,
    color: 'black'
  },
  values: [],
  labels: [],
  marker: {
    colors: []
  },
  hoverinfo: 'label+percent',
  hoverlabel: { bgcolor: 'white', font: { color: color('tertiaryButtonHoverText'), size: 15, family: 'Inter' } },
  hovertemplate: '%{label}: ' + '<br>%{percent}<br>' + '<extra></extra>',
  automargin: false // Plotly lib issue. Throws Too many redraw issue if it sets to True.
}

const CONFIG: Partial<Plotly.Config> = {
  scrollZoom: false,
  displaylogo: false,
  autosizable: true,
  responsive: true,
  modeBarButtonsToRemove: ['toImage']
}

const filterCustomers = (customers, variant, days) => {
  return _.filter(customers, customer => {
    const periodStartDate = moment().subtract(days, 'days')

    const customerStartDate = moment(customer.createdAt)

    if (variant === 'new') {
      return customerStartDate && customerStartDate.isSameOrAfter(periodStartDate)
    } else if (variant === 'existing') {
      return customerStartDate && customerStartDate.isBefore(periodStartDate)
    }
  })
}

const createCustomerStatusBreakdown = (customers) => {
  const chartData: Array<{ name: string, y: number, color: string }> = [
    { name: NO_SYSTEMS, y: 0, color: color(replace(`customerAdaption${NO_SYSTEMS}`, ' ', '')) },
    { name: OPTED_OUT, y: 0, color: color(replace(`customerAdaption${OPTED_OUT}`, ' ', '')) },
    { name: SOME_SYSTEMS_OPTED_IN, y: 0, color: color(replace(`customerAdaption${SOME_SYSTEMS_OPTED_IN}`, ' ', '')) },
    { name: OPTED_IN, y: 0, color: color(replace(`customerAdaption${OPTED_IN}`, ' ', '')) }
  ]

  _.each(customers, (customer) => {
    if (isFullyOptedIn(customer)) {
      chartData[3].y += 1
    } else if (isPartiallyOptedIn(customer)) {
      chartData[2].y += 1
    } else if (customer.devices?.length) {
      chartData[1].y += 1
    } else {
      chartData[0].y += 1
    }
  })

  const filteredChartData = _.reject(chartData, (data) => data.y === 0)

  const data: Plotly.Data = {
    ...DATA,
    values: filteredChartData.map((data) => data.y),
    labels: filteredChartData.map((data) => data.name),
    marker: {
      colors: filteredChartData.map((data) => data.color)
    }
  }

  return { layout: LAYOUT, data, config: CONFIG, hasData: filteredChartData.length > 0 }
}

const isFullyOptedIn = (customer) => {
  if (customer.devices?.length) {
    return _.every(customer.devices, (device) => device.optedIn)
  } else {
    return false
  }
}

const isPartiallyOptedIn = (customer: CustomerAdoption) => {
  if (customer.devices?.length) {
    return _.some(customer.devices, (device) => device.optedIn)
  } else {
    return false
  }
}

export const chartOptions = (variant: 'new' | 'existing', customers: Array<CustomerAdoption>, timeSpanInDays: number) => {
  return createCustomerStatusBreakdown(filterCustomers(customers, variant, timeSpanInDays))
}
